import * as React from "react";
import { CollectionList } from "../../CollectionNewSearchPage/CollectionList/CollectionList";
import { ICollectionListItem } from "../../CollectionNewSearchPage/CollectionListItem/CollectionListItem";
import { CollectionImageComponentTranslations } from "../CollectionImageComponentTranslations.csharp";
import classNames from "classnames";

export const CollectionItemPageList = ({
    translations,
    items,
    title,
    smallHeading,
    isVirtualObject
}: {
    translations: CollectionImageComponentTranslations;
    items: any[];
    title: string;
    smallHeading?: boolean;
    isVirtualObject?: boolean;
}) => {
    const [itemsToShow, setItemsToShow] = React.useState<number>(10);

    const mappedItems: ICollectionListItem[] = items.map((item) => ({
        title: item.title || "",
        medium: item.medium || "",
        primaryMedia: "",
        mediaId: item.mediaId || "",
        imageUrl: item.imageUrl,
        displayDate: item.displayDate || "",
        invNo: item.invNo || "",
        linkToObjectPage: "",
        isVirtualObject: item.isVirtualObject,
        numberOfChildren: item.numberOfChildren,
        childrenPrimaryMedia: item.childrenPrimaryMedia,
        onDisplayLabel: translations.exhibitedIn
    }));

    const displayedItems = mappedItems.slice(0, itemsToShow);

    const hasMoreResults = mappedItems.length > itemsToShow;

    const handleShowMore = () => {
        setItemsToShow(mappedItems.length);
    };

    return (
        <div
            className={classNames("CollectionItemList", {
                "CollectionItemList--is-virtual-object": isVirtualObject,
            })}
        >
            <h2
                className={classNames("CollectionItemList__title", {
                    "CollectionItemList__title--small": smallHeading,
                })}
            >
                {title}
            </h2>

            <div className="CollectionItemList-container">
                <CollectionList items={displayedItems} />
                {hasMoreResults && (
                    <div className="CollectionItemList__show-more-button">
                        <button onClick={handleShowMore}>{translations.showMore}</button>
                    </div>
                )}
            </div>
        </div>
    );
};
